import { defineMessages } from "react-intl"

export default defineMessages({
  contactSupport: {
    defaultMessage: "Contact Support",
    id: "src.components.Menu.contactSupport",
  },
  myTrips: {
    defaultMessage: "My Trips",
    id: "src.components.Menu.myTrips",
  },
  scheduleRental: {
    defaultMessage: "Schedule Rental",
    id: "src.components.Menu.scheduleRental",
  },
})
